import Vue from 'vue';
const UpDown = Vue.extend({
    props: {
        /** show top arrow */
        up: { type: Boolean, required: false, default: false },
        /** show bottom arrow */
        down: { type: Boolean, required: false, default: false },
        /** x position if within another SVG. Can be any valid unit string (px, %, etc)  */
        x: { type: [Number, String], required: false, default: '0px' },
        /** y position if within another SVG. Can be any valid unit string (px, %, etc)  */
        y: { type: [Number, String], required: false, default: '0px' },
        /** SVG width.  Number of px */
        width: { type: Number, required: false, default: 7 },
        /** SVG height.  Number of px  */
        height: { type: Number, required: false, default: 12 },
    },
    computed: {
        triangleHeight() {
            return (this.height / 12) * 5;
        },
        gap() {
            return this.height / 6;
        },
    },
});
export default UpDown;
